/**
 * BCP-47 locales supported for UI message catalogs. This tuple is the single
 * place the set is written down - the UiLocale union is derived from it, so the
 * two cannot disagree, and i18n's `Record<UiLocale, Messages>` then forces a
 * catalog for each.
 */
export const UI_LOCALES = ["en", "pt-BR", "es"] as const;

export type UiLocale = (typeof UI_LOCALES)[number];

export const DEFAULT_UI_LOCALE: UiLocale = "en";

/**
 * The default learning pair lives in @lib/courseConstants, beside the course
 * slug it belongs to. It used to be declared here as well, with the same values
 * - two constants of the same name that agreed only by luck.
 */

/** @deprecated Use UiLocale - kept briefly for incremental migration. */
export type AppLocale = UiLocale;
